import { NavLink, Link } from 'react-router-dom';
import { S } from '@/shared/constants/styles';
import { fmtAUD } from '@/shared/utils/formatCurrency';

const NAV_ITEMS = [
  { id: 'dashboard', icon: '\u{1F4CA}', label: 'Dashboard' },
  { id: 'transactions', icon: '\u{1F4B3}', label: 'Transactions' },
  { id: 'budget', icon: '\u{1F3AF}', label: 'Budget' },
  { id: 'bills', icon: '\u{1F4CB}', label: 'Bills' },
  { id: 'list', icon: '🛒', label: 'Shopping List' },
  { id: 'categories', icon: '\u{1F3F7}', label: 'Categories' },
  { id: 'overview', icon: '\u{1F4C8}', label: 'Year Overview' },
  { id: 'savings', icon: '\u{1F3E0}', label: 'Savings Goals' },
  { id: 'networth', icon: '\u{1F4B0}', label: 'Net Worth' },
  { id: 'settings', icon: '\u{2699}\u{FE0F}', label: 'Settings' },
];

export { NAV_ITEMS };

export default function Sidebar({ sideOpen, setSideOpen, householdName, inviteCode, resolvedMemberNames, resolvedUserName, monthNet, onLogout }) {
  return (
    <aside className={'sidebar-nav' + (sideOpen ? ' open' : '')} role="navigation" aria-label="Main navigation" style={{ width: 220, background: 'linear-gradient(180deg,#0f172a,#1e293b)', color: 'white', display: 'flex', flexDirection: 'column', flexShrink: 0, top: 0, left: 0, bottom: 0, zIndex: 40, transition: 'transform 0.2s' }}>
      <div style={{ padding: '20px 18px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: -0.3 }}>Budget Tracker</div>
        <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 3 }}>{householdName}</div>
        {resolvedMemberNames.length > 0 && <div style={{ fontSize: 10, color: '#64748b', marginTop: 4 }}>{resolvedMemberNames.join(' & ')}</div>}
        <div style={{ fontSize: 10, color: '#22c55e', marginTop: 6 }}>{'\u25CF'} Live sync</div>
        {inviteCode && <div style={{ fontSize: 10, color: '#475569', marginTop: 4 }}>Code: <span style={{ color: '#60a5fa', fontWeight: 700, letterSpacing: 1.5 }}>{inviteCode}</span></div>}
      </div>
      <nav style={{ flex: 1, paddingTop: 6 }}>
        {NAV_ITEMS.map((n) => (
          <NavLink
            key={n.id}
            to={'/' + n.id}
            onClick={() => setSideOpen(false)}
            style={({ isActive }) => ({
              width: '100%', display: 'flex', alignItems: 'center', gap: 10,
              padding: '12px 18px', border: 'none', cursor: 'pointer', fontSize: 13,
              background: isActive ? 'rgba(255,255,255,0.08)' : 'transparent',
              color: isActive ? 'white' : '#94a3b8',
              fontWeight: isActive ? 600 : 400,
              borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
              textAlign: 'left', transition: 'all 0.15s', minHeight: 44,
              textDecoration: 'none', boxSizing: 'border-box',
            })}
          >
            <span style={{ fontSize: 15 }}>{n.icon}</span><span>{n.label}</span>
          </NavLink>
        ))}
      </nav>
      <div style={{ padding: '14px 18px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ fontSize: 10, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5 }}>Net this month</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: monthNet >= 0 ? '#34d399' : '#f87171', marginTop: 2 }}>{'$' + fmtAUD(monthNet)}</div>
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#94a3b8' }}>{resolvedUserName}</span>
          <button onClick={onLogout} style={{ ...S.link('#f87171'), fontSize: 11 }}>Sign out</button>
        </div>
        <div style={{ marginTop: 8, display: 'flex', gap: 8, justifyContent: 'center' }}>
          <Link to="/privacy" onClick={() => setSideOpen(false)} style={{ fontSize: 10, color: '#475569', textDecoration: 'none' }}>Privacy</Link>
          <span style={{ fontSize: 10, color: '#334155' }}>&middot;</span>
          <Link to="/terms" onClick={() => setSideOpen(false)} style={{ fontSize: 10, color: '#475569', textDecoration: 'none' }}>Terms</Link>
        </div>
      </div>
    </aside>
  );
}
